import React, { FC, memo, useCallback } from 'react'

import { useMutation } from '@apollo/client'

import { CANCEL_APPLYING_DISCOUNT_CODE } from 'Const'
import { refreshingOrderTotalInSafari } from 'Utils'

interface Props {
  id: string
  isValid: boolean
  name: string
}

const CodeBtn: FC<Props> = ({ id, name, isValid }) => {
  const [cancelApplyingDiscountCode] = useMutation(CANCEL_APPLYING_DISCOUNT_CODE, {
    variables: { id },
    update() {
      refreshingOrderTotalInSafari()
    },
  })
  const handleRemove = useCallback(() => void cancelApplyingDiscountCode(), [cancelApplyingDiscountCode])

  return (
    <button aria-label="Remove discount code" className="btn" type="button" onClick={handleRemove}>
      <span className={isValid ? '' : 'invalid-code'}>{name}</span>
      <svg className="sociavore-icon" viewBox="0 0 24 24">
        <line x1="18" x2="6" y1="6" y2="18"></line>
        <line x1="6" x2="18" y1="6" y2="18"></line>
      </svg>
    </button>
  )
}

export default memo(CodeBtn)
